module.exports = __webpack_public_path__ + "static/medical-app-cover-65591509ec23af6a5c7dc619ff76c733.png";